import { render, staticRenderFns } from "./item-child.vue?vue&type=template&id=0fbe45f0"
import script from "./item-child.vue?vue&type=script&lang=js"
export * from "./item-child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports